import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PermissionMatrixActions = {
  fetchPermissionsMatrix: async ({ commit }) => {
    return axiosRequest.
      get('/admin/permissions_matrix').
      then(({ data }) => {
        commit('setPermissionsMatrix', data)
        return data
      }).
      catch(handleError)
  },
}

export const PermissionMatrixMutations = {
  setPermissionsMatrix: (state, matrix) => {
    state.matrix = matrix
  },
}

export const PermissionMatrixGetters = {
  permissionsMatrix: state => state.matrix,
}

export const PermissionMatrixState = {
  matrix: null,
}
